import { ISessionStorageServiceConfig } from './session.service.config';
import { Injectable, Inject } from '@angular/core';

export interface ISessionStorageService {
  set(key: string, object: any): void;
  get<T>(key: string): T;
  remove(key: string): void;
  clear(): void;
}

@Injectable()
export class SessionStorageService implements ISessionStorageService {

  private sessionStorage: Storage;

  constructor(@Inject('SESSION_STORAGE_SERVICE_CONFIG') private config: ISessionStorageServiceConfig) {
    this.sessionStorage = window.sessionStorage;
  }

  public set(key: string, object: any): void {
    this.sessionStorage.setItem(this.keyGen(key), JSON.stringify(object));
  }

  public get<T>(key: string): T {
    return JSON.parse(this.sessionStorage.getItem(this.keyGen(key))) as T;
  }

  public remove(key: string): void {
    this.sessionStorage.removeItem(this.keyGen(key));
  }

  public clear(): void {
    this.sessionStorage.clear();
  }

  private keyGen(key: string): string {

    if (this.config.prefix.length < 5) { throw new RangeError('Session storage prefix length must be greater then 4.'); }

    return `${this.config.prefix}_${key}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/session.storage.service/session.storage.service.ts